<ng-container *ngIf="promotion$ | async as promotion; else skeleton">
  <app-breadcrumb
    [items]="(breadcrumbs$ | async) ?? []"
    [title]="(title$ | async) ? titleTemplate : ''"
    [backButton]="true"
  ></app-breadcrumb>
  <ng-template #titleTemplate>
    <div class="grid">
      <div class="grid-item grid-9 grid-sm-12">
        <h1 class="typography typography-h1">{{ title$ | async }}</h1>
      </div>
    </div>
  </ng-template>

  <div class="section section-has-sider">
    <div class="section-content section-sider-mobile-top grid">
      <div class="section-main min-w-128">
        <div
          class="typography typography-body mb-20 red"
          *ngIf="promotion.status !== PromotionStatus.Active"
        >
          * В настоящее время акция недоступна в&nbsp;вашем регионе
        </div>

        <img
          *ngIf="promotion?.imageBig as imageBig"
          [src]="imageBig"
          [alt]="imageBig"
          loading="lazy"
          class="full-width rounded-s mb-48"
        />

        <div
          class="html-markup html-markup-l"
          [innerHTML]="promotion.text ?? '' | safeHtml"
        ></div>

        <ng-container *ngIf="!!promotion.promotionCenters && promotion.promotionCenters.length > 0">
          <div
            class="typography typography-bold typography-h4 mt-48 mb-40"
            #mapContainer
          >
            {{mapTitle$ | async}}
          </div>
          <app-promotion-map [centers]="promotion.promotionCenters"></app-promotion-map>
        </ng-container>
        <app-backtop></app-backtop>
      </div>

      <div
        class="section-sider grid-item grid-3 grid-lg-4 grid-sm-6 grid-xs-12"
      >
        <app-promotion-side-bar
          [startDate]="promotion.startDate"
          [endDate]="promotion.endDate"
          [showGoToMap]="!!mapContainer"
          (goToMapClick)="scrollToMap()"
        ></app-promotion-side-bar>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #skeleton>
  <app-skeleton></app-skeleton>
</ng-template>
